<template>
  <v-dialog
    v-if="confirmation"
    v-model="modal">
    <v-btn
      v-if="canRefund"
      slot="activator"
      :loading="loading"
      error light>
      {{ title || $t('purchase.refund.refund') }}
    </v-btn>
    <v-card>
      <v-card-text>
        <p>
          {{ $t('purchase.refund.refundText') }}
        </p>
        <v-text-field v-model="reason" :label="$t('purchase.refund.reason')"/>
      </v-card-text>
      <v-card-row actions>
        <v-btn
          @click.native.stop="refund()"
          :loading="loading"
          error block light>
          {{ title || $t('purchase.refund.refund') }}
        </v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>
  <v-btn
    v-else-if="canRefund"
    @click.native.stop="refund()"
    :loading="loading"
    error light>
    {{ title || $t('purchase.refund.refund') }}
  </v-btn>
  <span v-else></span>
</template>

<script>
  import { mapActions } from 'vuex'
  import Purchase from '@/api/purchase'
  import purchase from '@/mixins/purchase'
  export default {
    mixins: [purchase],
    props: {
      confirmation: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        modal: false,
        reason: ''
      }
    },
    computed: {
      canRefund () {
        return Purchase.isRefundable(this.purchase)
      }
    },
    methods: {
      ...mapActions({
        refundNow: 'skiliko/purchases/refund'
      }),
      refund () {
        this.refundNow({ id: this.purchase.id, reason: this.reason })
          .then(_ => (this.modal = false))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Refund.vue